import Event from '../../core/Event';

export default class EstimationProductsGetFailed extends Event {
    public static type = 'EstimationProductsGetFailed';

    constructor() {
        super(EstimationProductsGetFailed.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/products/events/EstimationProductsGetFailed.ts